import { useFlag } from '@mentimeter/flags/confidence/client';
import { useMemo } from 'react';

/**
 * Removes /invite and everything after it from a URL string
 * @param url - The URL string to clean
 * @returns The cleaned URL without /invite and subsequent content
 */
function cleanPresentationPath(url: string): string {
  return url.replace(/(^\/app\/presentation\/\w+\/)(.*$)/, '$1');
}

export function useContinueUrl(
  redirectUrl: string | null,
  inviteToken: string,
): string | null {
  const { value: confirmWorkspaceInviteFullPage } = useFlag(
    'mangos-confirm-workspace-invite-full-page.enabled',
    false,
  );
  return useMemo(() => {
    if (!redirectUrl) {
      return null;
    }

    if (
      confirmWorkspaceInviteFullPage === true &&
      redirectUrl.includes('presentation')
    ) {
      // 2. Experiment on & invited to presentation
      return `/app/join-workspace/${inviteToken}/confirm?continueUrl=${cleanPresentationPath(redirectUrl)}`;
    }

    if (confirmWorkspaceInviteFullPage === true) {
      // 1. Experiment on & invited to workspace
      return `/app/join-workspace/${inviteToken}/confirm`;
    }

    // 3. Experiment off & invited to workspace - home page
    // 4. Experiment off & invited to presentation - presentation with modal
    return redirectUrl;
  }, [redirectUrl, confirmWorkspaceInviteFullPage, inviteToken]);
}
